import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import type {
  ExecutionsHistoryOverviewSection,
} from '@src/models/interfaces/executionsHistoryDashboard.interface';
import type { SectionStatus } from '@src/packages/dashboard/components/ReportSummary';
import { getHistorySectionErrorMessageId } from '@src/packages/dashboard/components/ReportSummary/historySectionErrorMessageIds';

import type { HistorySectionState } from './useExecutionsHistorySections';

/** Maps a history section load state to the status shown by report blocks. */
export const useSectionStatus = (retry: (section: ExecutionsHistoryOverviewSection) => void) => {
  const intl = useIntl();

  return useCallback(
    (section: ExecutionsHistoryOverviewSection, state: HistorySectionState): SectionStatus => {
      if (state.loading || !state.result) return { kind: 'loading' };
      if (state.result.status === 'ok') return { kind: 'ready' };
      return {
        kind: 'error',
        message: intl.formatMessage({ id: getHistorySectionErrorMessageId(state.result.errorCode) }),
        retryLabel: intl.formatMessage({ id: 'dashboards.tasks.summary.section.retry' }),
        onRetry: () => retry(section),
      };
    },
    [intl, retry],
  );
};
